import {toast} from "react-toastify"


export const SuccessToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose:3000,
    })
}

export const ErrorToast = (message) => {
    toast.error(message, {
        position: "top-right",
        autoClose:3000,
    })
}


export const InfoToast = (message) => {
    toast.info(message, {
        position: "top-right",
        autoClose:3000,
    })
}


export const CreatedToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose:3000,
    })
}

export const UpdatedToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose:3000,
    })
}

export const UpdateErrorToast = (message) => {
    toast.error(message, {
        position: "top-right",
        autoClose:3000,
    })
}

export const CreatedErrorToast = (message) => {
    toast.error(message, {
        position: "top-right",
        autoClose:3000,
    })
}